import DomainAddIcon from '@mui/icons-material/DomainAdd';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';

import { GenericStatusEnum, ThirdPartyTypeEnum } from '@e-socna/data-layer';

import { SpeedDial } from '../../../components/SpeedDial';
import { ThirdParties } from '../../../components/ThirdParties';
import {
  PATH_EXTERNAL_ORGANIZATIONS_NEW,
  PATH_EXTERNAL_ORGANIZATIONS_SEARCH,
  PATH_INTERNAL_ORGANIZATIONS_NEW,
} from '../../../app/constants/paths.constant';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

interface Props {
  readonly isInternal: boolean;
}

export const OrganizationsTabPanel = ({ isInternal }: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  const speedDialActions = [
    ...(isInternal
      ? [
          {
            id: 'createInternalOrganization',
            icon: <DomainAddIcon />,
            name: 'Créer Société SOCNA',
            to: PATH_INTERNAL_ORGANIZATIONS_NEW,
          },
        ]
      : [
          {
            id: 'createExternalOrganization',
            icon: <DomainAddIcon />,
            name: 'Créer Organisation',
            to: PATH_EXTERNAL_ORGANIZATIONS_NEW,
          },
          {
            id: 'searchOrganization',
            icon: <ScreenSearchDesktopIcon />,
            name: 'Recherche',
            to: PATH_EXTERNAL_ORGANIZATIONS_SEARCH,
          },
        ]),
  ];

  return (
    <>
      <ThirdParties
        initialGridState={initialGridState}
        isInternal={isInternal}
        kind={ThirdPartyTypeEnum.Organization}
        status={GenericStatusEnum.Enabled}
      />
      <SpeedDial
        actions={speedDialActions}
        title="Actions possibles sur les Organisations"
      />
    </>
  );
};
